<div class="apply-start mx-auto my-4">
    <h1 class="mt-0">Apply for a permit</h1>

    <app-permit-type-chooser></app-permit-type-chooser>

    <p class="text-muted small mt-4 mb-0">Already applied? <a routerLink="/my-permits">View your permits</a>.</p>

    <!-- Below the chooser, not beside it: almost everyone here wants a permit, and an
         organisation applying for a login is the rarer errand. Worded so someone who
         needs a permit today does not mistake this for a step they have to take. -->
    <hr class="my-4" />
    <p class="text-muted small mb-0">
        <strong>Bringing staff, clients or guests to the Islands regularly?</strong>
        An organisation can <a routerLink="/business-login">apply for a Business Login</a> and issue permits.
    </p>
</div>
